function getNameFromUrl(url) {
  if (typeof url !== "string") return " ";
  return decodeURIComponent(url.replace(/^.*?\/([^\/]*?\.[^\/]*)$/, "$1"));
}
export default getNameFromUrl